module.exports = __webpack_public_path__ + "static/img/one.e4a31e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/10/one.png
// module id = Jeje
// module chunks = 1